var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-loader",class:{'backdrop': _vm.hasBg}},[_c('div',{staticClass:"base-loader__wrap",class:_vm.position ? ("pos-" + _vm.position) : ''},[_c('dot-loader',{attrs:{"color":_vm.dotColor}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }